/*
  This page is for Account activation
  Author: Surojit Basu
  Date: Jan 20, 2021
*/
import React,{useEffect,useState,useContext} from 'react';
import {  
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Alert,
  ProgressBar
} from 'react-bootstrap';

import {MessageModal} from '../components';

import UserContext from './../contexts/UserContext';

import './login.css';

const Password = (props) => {

  const {changePassword, logout} = useContext(UserContext);  
  const [loading,setLoading] = useState(false);
  const [message,setMessage] = useState(false); 

  const goPrev = () => {
    window.history.back();
  }

  const onSubmit = (e) => {
    var frm = e.currentTarget;
    e.preventDefault();
    var data = {
      opass: frm.opass.value,
      npass: frm.npass.value,
      cpass: frm.cpass.value
    };

    if(data.npass != data.cpass){
      setMessage(['error','Mismatched! Please confirm your password correctly.']);
      frm.npass.value = '';
      frm.cpass.value = '';
      frm.npass.focus();
      return false;
    }

    setLoading(true);
    changePassword(data,(success,message) => {
      setLoading(false);
      setMessage([success ? 'success' : 'error',message]);
      if(success){
        frm.reset();
        logout(() => {
          window.setTimeout(()=> {
            window.location.reload();
          }, 2000);
        });
        // do nothing      
      }
    });
  }

  return <Container>
    <div className="mb-3"><span className="clickable" onClick={goPrev} title="Back to Previous Screen"><img src={`${process.env.PUBLIC_URL}/images/back_arrow.png`} alt="Back" /> Back</span></div>
    <div className="heading mb-4">Change Your Current Password</div>
    <Card className="card-shadowed ml-0">
      <Card.Body>       
        <Row>
          <Col className="header">            
              Secure your account by changing your password time to time.
          </Col>
        </Row>

        {message && <MessageModal type={message[0]} message={message[1]} onHide={() => {setMessage(false);}} />}

        {loading && <Alert variant="light" className="p-3">
          <p className="loading-msg">Change password requesting..</p>
          <ProgressBar variant="info" animated now={100} />
        </Alert>}
        
        {!loading && <>
                    
          <Form className="mt-4 mb-4" onSubmit={onSubmit}>
            <Row>
              <Col sm={6}>
                <Form.Control required className="input-text" type="password" placeholder="* Enter your current password" name="opass" />                                
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Control required className="input-text" type="password" placeholder="* Enter new password" name="npass" />                                
              </Col>
              <Col sm={6}>
                <Form.Control required className="input-text" type="password" placeholder="* Confirm new password" name="cpass" />                                
              </Col>
            </Row>                         
            <Row className="mt-4 mb-0">
              <Col className="text-right"><Button type="submit" className="p-0 clear"><img src={`${process.env.PUBLIC_URL}/images/go_button.png`} alt="Change Password" /></Button></Col>
            </Row>            
          </Form>    
        </>}
      </Card.Body>
    </Card>  
  </Container>

}

export default Password;